import { useEffect, useState } from 'react';
var useMediaQuery = function (query) {
    var getMatches = function (q) {
        if (typeof window !== 'undefined') {
            return window.matchMedia(q).matches;
        }
        return false;
    };
    var _a = useState(getMatches(query)), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        var matchMedia = window.matchMedia(query);
        var handleChange = function () {
            setMatches(getMatches(query));
        };
        handleChange();
        matchMedia.addEventListener('change', handleChange);
        return function () { return matchMedia.removeEventListener('change', handleChange); };
    }, [query]);
    return matches;
};
export default useMediaQuery;
//# sourceMappingURL=use-media-query.js.map